// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"6c32e94b","489":"a95746c7","494":"b7b13129","553":"e322a9bf","693":"76b081dc","764":"fd96b1c1","781":"aff5c5e1","892":"3feb5a8e","954":"f10731ef","975":"607eaf4e"}[chunkId] + ".chunk.js";
};